import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isUndefined, isNullOrUndefined } from 'util';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastyService, ToastOptions } from 'ng2-toasty';

import { OverviewDialogComponent } from '../newSurveyDialog/overview-dialog.component';
import { BlankSurveyDialogComponent } from '../newSurveyDialog/blank-survey-dialog.component'
import { SurveyTypeDialogComponent } from '../newSurveyDialog/surveytype.component';
import { RangeForRepeaterDialogComponent } from '../range-for-repeater-dialog/range-for-repeater-dialog.component';
import { ShareSurveyservice } from './share-superadmin-dialog';
import { shareSurvey } from './share-admin-dialog';
import { Templateservice } from './new-template';
import { AccessSurveyservice } from './AccessSurveyservice';
import { tutorialComponent } from '../tutorial/tutorialComponent'
import { Anomalies } from '../classes/anomaly';
import { QuestionnaireTemplate } from '../classes/questionnaireDetail';

import { RestApiService } from '../shared/restApiServices/restapi.service';
import { ShowToastyService } from '../shared/services/showToastyService';
import { NativeWindoRefService } from '../shared/services/native-windo-ref.service';
import { superAdminService } from '../shared/services/superAdminService';
import { TabsDataService } from '../shared/services/tabs-data.service';
import { ViewSurveyservice } from './viewInfoservice';
import { ResponseChartComponent } from '../response-chart-dialog/response-chart.component';
import { AddTeamDialogComponent } from 'app/surveyers/surveyers.component';
import { AssignTeamComponent } from 'app/centralPanel/central-panel.component';

declare var amplitude:any;
var copyQnr:any;

@Component({
  selector: 'app-questionnaires',
  templateUrl: './questionnaires.component.html',
  styleUrls: ['./questionnaires.component.css']
})
export class QuestionnairesComponent implements OnInit {
  surveyname:string;
  shgname:string;
  questions:any;
  questionsLength:number;
  cascad:any;
  child_group:any;
  sub_form:any = [];
  surveyDetails:any;
  qnrList: any[];
  filter:string;
  nativeWindow: any;
  showLoader: boolean;
  noSurveyCreated: boolean;
  userTemplates: QuestionnaireTemplate[];
  text: string;
  emptyList:boolean;
  superAdmin:boolean;
  count :number = 0;
  filterList:any[];
  SHG:boolean = false;
  notSHG:boolean = true;
  previewToggleLabel : string = 'Preview';
  qID:any;
  
  //Error message if JSON is not loaded properly
  //Will be replaced later when Json is loaded from broadcasting service
  errorMessage: string;

  //An array to store all the questions
  //will refrence the questions array from broadcasting service later

  anomalies : Anomalies[];

  showAnomalyRepeater : boolean = false;
  showAnomaly : boolean = false;


  shouldIShowRepeaterDialogBox : string = "";

  simpleAnomalyHeading : string =  "";
  simpleAnomalyMsg :string =  "";
  simpleAnomalyMsg_S :string =  "";
  repeaterAnomalyHeading :string =  "";
  repeaterAnomalyMsg : string = "";
  repeaterAnomalyMsg_S : string = "";
  wasOverviewDialogCalled = false; //used to make sure that overview dialog opens only once
  qnrWithVisibleDropdown;
  userHeader:string;
  companyName:string;
  switchOrgList:{orgName:string,superAdminID:string}[]=[];

  constructor(public superAdminService:superAdminService, public router: Router, 
    public dialog: MatDialog, private restApiService: RestApiService, 
    nativeWindoRefService: NativeWindoRefService, private toastyService: ToastyService, 
    private tabsDataService:TabsDataService,private showToastyService:ShowToastyService,
    private route:ActivatedRoute,) {
    this.filter="";
    this.nativeWindow = nativeWindoRefService.getNativeWindow();
    this.showLoader = true;
    this.noSurveyCreated = false;
    this.emptyList=false;
    this.count = 0;
    // getting username header.
    this.userHeader = localStorage.getItem("user_name_header");
    this.restApiService.orgName.subscribe(response=>{
      if(response){
        this.companyName = response;
        this.switchOrgList = this.restApiService.getSwitchOrgList();
        this.getQnrList2();

      }
    })
    this.restApiService.goToSurveys.subscribe(response=>{
      if(response && this.SHG && !this.notSHG){
        this.goback();
      }
    })

    if (this.superAdminService.hasData()) {
      this.superAdmin = this.superAdminService.getData();
    } else {
      this.restApiService.checkIfSuperAdmin().subscribe(
        result => {
          if (result.checkIfSuperAdmin == true) {
            this.superAdmin = true;
            this.superAdminService.setData(this.superAdmin);
          }
          else {
            this.superAdmin = false;
            this.superAdminService.setData(this.superAdmin);
          }
        });
    }
    // disabeling tutorial.
    // if(localStorage.getItem('displaytutorial')==undefined) {
    //   var object = { value: true, timestamp: new Date().getTime() }
    //   localStorage.setItem("displaytutorial", JSON.stringify(object));
    //   let dialogRef = this.dialog.open(tutorialComponent, {
    //     height: '82%',
    //     width: '76%'
    //   });
    //   dialogRef.afterClosed().subscribe(() => {
    //     var object = { value: false, timestamp: new Date().getTime() }
    //     localStorage.setItem("displaytutorial", JSON.stringify(object));
    //   });
    // }
    // else if(JSON.parse(localStorage.getItem("displaytutorial")).value == true)
    // {
    //   let dialogRef = this.dialog.open(tutorialComponent, {
    //     height: '82%',
    //     width: '76%'
    //   });
    //   dialogRef.afterClosed().subscribe(() => {
    //     var object = { value: false, timestamp: new Date().getTime() }
    //     localStorage.setItem("displaytutorial", JSON.stringify(object));
    //   });
    // }
    // else if(JSON.parse(localStorage.getItem("displaytutorial")).value ==false)
    // {
    //   var data = JSON.parse(localStorage.getItem("displaytutorial")),
    //   dateString = data.timestamp,
    //   now = new Date().getTime();
    //   if((now-dateString)>=2592000000)
    //   {
    //     var object = { value: true, timestamp: new Date().getTime() }
    //     localStorage.setItem("displaytutorial", JSON.stringify(object));
    //   }
    // }
    // this.tabsDataService.createNewForm.subscribe(data=>{
    //   if(data){
    //     console.log("openning survey",data);
    //     this.openAddSurveyDialog();
    //   }
    // })

    this.route.queryParams.subscribe(query=>{
      if(query && query.createHr){
        this.router.navigate([], {
          queryParams: {
            'createHr': null,
          },
          queryParamsHandling: 'merge'
        });
        this.openAddSurveyDialog();
      }
    })

    this.companyName = localStorage.getItem('companyName');
  }

  ngOnInit() {
    this.getQnrList();
    this.switchOrgList = this.restApiService.getSwitchOrgList();
    // this.getUserTemplates();
  }

  onSelectOrg(org:{orgName:string,superAdminID:string}){
    if(org && org.superAdminID && org.superAdminID != undefined && org.orgName){
      localStorage.setItem('superAdminID',org.superAdminID);
      localStorage.setItem('companyName',org.orgName);
      this.companyName = org.orgName;
      // this.restApiService.orgName.next(this.companyName);
      this.getQnrList2();
    }
  }
  openSettings(){
    this.router.navigateByUrl('/userProfile');
  }

  viewPerformance(qnr){
    localStorage.setItem("selectedSIdForPerformance",qnr.qID);
    localStorage.setItem("selectedAdminIdForPerformance",qnr.adminID);
    localStorage.setItem("selectedSurveyName",qnr.surveyName);
    this.router.navigate(["./view-performance"]);
  }

  viewResponses(qnr){
    this.router.navigate(['./survey-data'],{
      queryParams:{
        'qnr':JSON.stringify(qnr)
      },
      queryParamsHandling: 'merge'
    })
  }

  openAddSurveyDialog(){
    let SurveyTypeDialogRef = this.dialog.open(SurveyTypeDialogComponent, {
      width: '800px',
      height: '54rem',
      data: 1
    });
    SurveyTypeDialogRef.afterClosed().subscribe(result => {
      if (result && result.success != false) {
        this.qnrList.length = 0;
        this.showLoader = true;
        this.tabsDataService.setSurveyTabDataTobeUpdated(true);
        this.getQnrList();
      }
      else if(this.tabsDataService.hasSurveyTabDataTobeUpdated() == true)
      {
        this.getQnrList(); 
      }
    });
  }

  goback(){
    this.SHG = false;
    this.notSHG = true;
    this.tabsDataService.setSurveyTabDataTobeUpdated(true);
    this.getQnrList();
  }
  
  createTemplate(data){
    if (data.question.length > 0) {
      let dialogRef = this.dialog.open(Templateservice, {
        width: '80%',
        height: '90%',
        data:data
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result!=undefined)
        {
        if (result.success != false) {
          var toastOptions: ToastOptions = {title: "Template Created", msg: "New template was successfully created.", showClose: true, timeout: 3000, theme: 'bootstrap'};
          this.toastyService.success(toastOptions);
          // this.getUserTemplates();
        }
        else {
          var toastOptions: ToastOptions = {title: "Could not Publish", msg: result.msg, showClose: true, timeout: 3000, theme: 'bootstrap'};
          this.toastyService.error(toastOptions);
        }
      }
      });
    }
    else {
      // console.log('no question present');
      var toastOptions: ToastOptions = {
        title: "Could not Publish",
        msg:"No questions present in the survey - "+ data.surveyName ,
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }
  }

  getQnrList() {
    if(!isNullOrUndefined(this.tabsDataService.getSurveyTabData()) && !this.tabsDataService.hasSurveyTabDataTobeUpdated())
    {
        this.noSurveyCreated = false;
        this.qnrList = this.tabsDataService.getSurveyTabData();
        this.count = this.qnrList.length;
        this.showLoader = false;
        this.filterList = this.qnrList;
        this.tabsDataService.setSurveyTabDataTobeUpdated(false);
    }
    else {
      let browserStorage = localStorage.getItem('browserStorage');
      if (!isUndefined(browserStorage) && browserStorage != null) {
        this.restApiService.getQnrListService().subscribe(
          result => {
            if(result.success){
              this.qnrList = result['result'];
              this.filterList = this.qnrList;
              this.count = this.qnrList.length;
              if (this.qnrList == null || isUndefined(this.qnrList) || this.qnrList.length == 0) {
                this.noSurveyCreated = true;
              }
              else{
                this.noSurveyCreated = false;
                //set qnrList in tab service
                this.tabsDataService.setSurveyTabData(this.qnrList);
                this.tabsDataService.setSurveyTabDataTobeUpdated(false);
              }
            }
            this.showLoader = false;
          });
      }
    }
  }

  getQnrList2(){
    this.restApiService.getQnrListService().subscribe(
      result => {
        if(result.success){
          this.qnrList = result['result'];
          this.filterList = this.qnrList;
          this.count = this.qnrList.length;
          if (this.qnrList == null || isUndefined(this.qnrList) || this.qnrList.length == 0) {
            this.noSurveyCreated = true;
          }
          else{
            this.noSurveyCreated = false;
            //set qnrList in tab service
            this.tabsDataService.setSurveyTabData(this.qnrList);
            this.tabsDataService.setSurveyTabDataTobeUpdated(false);
          }
        }
        this.showLoader = false;
      });
  }

  changeActivityState(event, qnr) {
    let statusValue = event.target.checked;
    this.restApiService.changeActivityStatus(qnr.qID, statusValue).subscribe(
      result => {
        if (result.success) {
          qnr.isActiveStatus = statusValue;
          var toastOptions: ToastOptions = {
            title: "Status Updated",
            msg: qnr.surveyName + ' status changed to ' + (statusValue ? 'Active' : 'In Active'),
            showClose: true, timeout: 3000, theme: 'bootstrap'
          };
          this.toastyService.success(toastOptions);
        }
        else {
          // console.log("Error");
        }
      });
  }

  showFunction(qnr) {
    amplitude.getInstance().logEvent('carddropdownclicked');
    if (qnr.showDropdown == false || qnr.showDropdown == undefined) {
      qnr.showDropdown = true;
      if(this.qnrWithVisibleDropdown){
        this.qnrWithVisibleDropdown['showDropdown'] = false;
      }
    }
    else {
      qnr.showDropdown = false;
    }
    this.qnrWithVisibleDropdown = qnr;
  }

  onClickCloseDropdown(){
    if(this.qnrWithVisibleDropdown){
      this.qnrWithVisibleDropdown['showDropdown'] = false;
    }
    this.qnrWithVisibleDropdown = null;
  }
  editSurvey(qnr,type){
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Editinfo"});

    let dialogRef = this.dialog.open(EditSurveyInfoComponent, {
      height: '300px',
      width: '600px',
      data:qnr
    });
    dialogRef.afterClosed().subscribe(result => {
      if(Boolean(result) && result.success)
      {
        this.tabsDataService.setSurveyTabDataTobeUpdated(true);
        if(type == 2)
        {
          this.GetDetailsOfASubForm(this.qID);
        }
        else
        {
          this.showLoader = true;
          this.getQnrList();
        }
      }
    });
  }

  sharesurvey(qnr){
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Share"});

   if(this.superAdminService.getData())
   {
    let dialogRef = this.dialog.open(ShareSurveyservice, {
      width: '1120px',
      height: '560px',
      data:qnr
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getQnrList();
    });
  }
  else{
    let dialogRef = this.dialog.open(shareSurvey, {
      width: '1120px',
      height: '560px',
      data:qnr
    });
    dialogRef.afterClosed().subscribe(() => {
      this.tabsDataService.setSurveyTabDataTobeUpdated(true);
      this.getQnrList();
    });
  }
  }

  accessSurvey(qnr)
  {
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Surveyaccess"});

    let dialogRef = this.dialog.open(AccessSurveyservice, {
      width: '68%',
      height: '80%',
      data:qnr
    });
    dialogRef.afterClosed().subscribe(result => {
      this.tabsDataService.setSurveyTabDataTobeUpdated(true);      
      this.getQnrList();
      this.tabsDataService.setTeamsTabDataTobeUpdated(true);
    });
  }

  viewsurvey(qnr){
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Viewinfo"});
    let dialogRef = this.dialog.open(ViewSurveyservice, {
      width: '500px',
      data:qnr
    });
  }

  createCopy(qnr,type,form_type){
    //copyQnr=qnr;
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Createcopy"});
    let dialogRef = this.dialog.open(CopySurveyDialogComponent, {
      width: '550px',
      height: '260px',
      data:{qnr:qnr,qnr_type:type,form_type:form_type, surveyName: this.surveyname}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.tabsDataService.setSurveyTabDataTobeUpdated(true);
      this.getQnrList();
    });
  }

  deleteqnr(qnr,qnrName,type){
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Delete Survey"});

    let typeDefined = type;
    if(typeDefined == 2)
    {
      type = 1;
    }
    else{
      type = 0;
    }
    let dialogRef = this.dialog.open(DeleteSurveyDialogComponent, {
      height: '290px',
      width: '400px',
      data: { type: type, qID: qnr, surveyName: qnrName }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(typeDefined == 2)
      {
        this.GetDetailsOfASubForm(this.qID);
      }
      else
      {
        this.tabsDataService.setSurveyTabDataTobeUpdated(true);
        this.getQnrList();
        this.tabsDataService.setTeamsTabDataTobeUpdated(true);
      }
    });
  }
  download(qID,qnrName)
  {
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Download"});
    this.restApiService.getQnrExcel(qID,qnrName).subscribe(
      result => {
        // console.log(result);
        if(!(result == 'false'))
        {
          var a = document.createElement('a');
          a.href = result;
          a.target = '_blank';
          a.download = 'data.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        else{
          console.log("NO DATA");
        } 
    });
  }
  openDialogforSubForm(){
    let newSurveyDialogRef = this.dialog.open(BlankSurveyDialogComponent, {
      width: '800px',
      height: '54rem',
      data: {type:1,questionaire_type:1,form_type:"Sub",parentId:this.qID}
    });
    newSurveyDialogRef.afterClosed().subscribe(result => {
      if (result && result.success == true) {
        this.GetDetailsOfASubForm(this.qID);
      }
    });
  }

  searchclick()
  {
    amplitude.getInstance().logEvent('Searchclicked');

  }

  editQuestionnaire(ID){
    var currentAbsoluteUrl = this.nativeWindow.location.href;
    var currentRelativeUrl = this.router.url;
    var index = currentAbsoluteUrl.indexOf(currentRelativeUrl);
    var baseUrl = currentAbsoluteUrl.substring(0, index);
    window.open(baseUrl + '/create-questionnaire/' + ID);
  }


  movetotop(data){
    let temp:any[] = this.child_group;
    let index = temp.indexOf(data);
    var element = temp[index];
    temp.splice(index, 1);
    temp.splice(0, 0, element);
    this.restApiService.updatechildgroupservice(this.qID,temp).subscribe(value => {
      this.GetDetailsOfASubForm(this.qID);
    });
  }
  //To move the subform at the bottom
  movetobottom(data){
    let temp:any[] = this.child_group;
    let index = temp.indexOf(data);
    var element = temp[index];
    temp.splice(index, 1);
    temp.splice(temp.length, 0, element);
    this.restApiService.updatechildgroupservice(this.qID,temp).subscribe(value => {
      this.GetDetailsOfASubForm(this.qID);
    });
  }
  movedownby(data,position){
    let temp:any[] = this.child_group;
    let index = temp.indexOf(data);
    var element = temp[index];
    temp.splice(index, 1);
    if(index + position > temp.length){
      temp.splice(temp.length, 0, element);
    }
    else{
      temp.splice(index+position, 0, element);
    }
    this.restApiService.updatechildgroupservice(this.qID,temp).subscribe(value => {
      this.GetDetailsOfASubForm(this.qID);
    });
  }
  moveupby(data,position){
    let temp:any[] = this.child_group;
    let index = temp.indexOf(data);
    var element = temp[index];
    temp.splice(index, 1);
    if(index - position < 0){
      //console.log("Target position is ",0);
      temp.splice(0, 0, element);
    }
    else{
      //console.log("Target position is ",index-position);
      temp.splice(index - position, 0, element);
    }
    this.restApiService.updatechildgroupservice(this.qID,temp).subscribe(value => {
      this.GetDetailsOfASubForm(this.qID);
    });
  }

  moveKeyPressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  moveKeyup(event: any) {

    if (event.target.value.charAt(event.target.value.length - 1) === " ") {
      event.target.value = event.target.value.substring(0, event.target.value.length - 1);
    }
  }

  // getUserTemplates() {
  //   // console.log('getting user templates');
  //   let browserStorage = localStorage.getItem('browserStorage');
  //
  //   if (!isUndefined(browserStorage) && browserStorage != null) {
  //     // let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
  //     this.restApiService.getUserTemplates().subscribe(
  //       result => {
  //
  //         this.userTemplates = result.result;
  //       });
  //   }
  //
  // }
  //
  // useTemplate(type){
  //   this.restApiService.useTemplate(type).subscribe(
  //     result => {
  //       let qnr = result.result[0].question;
  //       console.log("qnr is ",qnr);
  //       this.openDialog(qnr);
  //     });
  // }
  isActiveStatus= false;
  openDialog(qnr){
    amplitude.getInstance().logEvent('CardClicked');
    if(qnr.child_group == null){
      if(!this.wasOverviewDialogCalled){
        this.GetDetailsOfASub(qnr.qID);
      }
      
    }
    else{
      this.SHG = true;
      this.notSHG = false;
      this.isActiveStatus = qnr.isActiveStatus;
      this.GetDetailsOfASubForm(qnr.qID);
    }
    this.superAdminService.setCloseMenu("close");
  }

  GetDetailsOfASub(temp)
  {
    this.wasOverviewDialogCalled = true;
    this.restApiService.getQnrWithDetailsService(temp).subscribe(value => {
      let newSurveyDialogRef = this.dialog.open(OverviewDialogComponent, {
        panelClass:'custom-dialog-class',
        height : '560px',
        width: '1120px',
        data: value.result[0]
      });
      newSurveyDialogRef.afterClosed().subscribe(result => {
      this.wasOverviewDialogCalled = false;
        if(result && result.success != false){
          this.getQnrList2(); // just to review... no need to update anything on close..
        }
      });

    })
  }
  

  GetDetailsOfASubForm(tempQID)
  {
    this.restApiService.getQnrWithDetailsService(tempQID).subscribe(value => {
      this.sub_form = [];
      for(var i = 0; i < value.result.length; i++){
        if(value.result[i].qID === tempQID){
          this.qID = tempQID;
          this.shgname = value.result[i].group_name;
          this.surveyDetails = value.result[i];
          this.surveyname = value.result[i].surveyName;
          this.questionsLength = value.result[i].num_qns;
          this.cascad = JSON.stringify(value.result[i].cascadeLocation);
          this.child_group = value.result[i].child_group;
          this.surveyDetails.isActiveStatus = this.isActiveStatus;
        }
        else{
          this.sub_form.push(value.result[i]);
        }
      }
      let temp:any = [];
      for(let i = 0; i < this.child_group.length; i++){
        for(let j = 0; j < this.sub_form.length; j++)
        {
          if(this.child_group[i] == this.sub_form[j].qID){
            temp.push(this.sub_form[j])
          }
        }
      }
      this.sub_form = temp;
    })
  }

  openPreview(qnr,subForm){ //same as openDialog when qnr.child_group == null
    if(subForm){
      qnr.hasSubForm = true;
    }
      let newSurveyDialogRef = this.dialog.open(OverviewDialogComponent, {
        panelClass:'custom-dialog-class',
        height : '560px',
        width: '1120px',
        data: qnr
      });
      newSurveyDialogRef.afterClosed().subscribe(result => {
        if(result && result.success != false){
          // this.getQnrList2(); // just to review... no need to update anything on close..
          // this.GetDetailsOfASubForm(this.qID);
          if(this.sub_form){
            this.goback();
          }
        }
      });
  }
  getTags(tagsArray) {

    let tags = '';
    let length = tagsArray.length - 1;
    for (let i = 0; i < tagsArray.length; i++) {
      tags += tagsArray[i];
      if (i < length) {
        tags += ',';
      }
    }
    return tags;
  }

  getQuestionnaireURL(qnr) {
    if(qnr.child_group == null){
      if(!this.wasOverviewDialogCalled){
        let Id = qnr.qID;
        var currentAbsoluteUrl = this.nativeWindow.location.href;
        var currentRelativeUrl = this.router.url;
        var index = currentAbsoluteUrl.indexOf(currentRelativeUrl);
        var baseUrl = currentAbsoluteUrl.substring(0, index);
        window.open(baseUrl + '/create-questionnaire/' + Id);
      }
      
    }
    else{
      this.SHG = true;
      this.notSHG = false;
      this.GetDetailsOfASubForm(qnr.qID);
    }
  }

  assignTeam(qnr){
    let data = {
      surveyId:qnr.qID,
      surveyName:qnr.surveyName,
      fromSurvey:true
    }
    let dialogRef = this.dialog.open(AssignTeamComponent, {
      width: '68%',
      height: '600px',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getQnrList2();
    });
  }

  searchSurvey(data) {
    if (data.key >= 'a' && data.key <= 'z' || data.key == ' '|| data.key>=0 && data.key<=9||data.key == '_'|| data.key =='.' ||data.key == ','||data.key==' '||data.key=='-') {
      this.filterList = [];
      this.emptyList=true;
      this.filter += data.key.toLowerCase();
      for (var i = 0; i < this.qnrList.length; i++) {
        if (this.qnrList[i].surveyName.toLowerCase().includes(this.filter)) {
          this.filterList.push(this.qnrList[i]);
          this.emptyList=false;
        }
      }
    }
    else if (data.key == 'Backspace') {
      if(this.text == '' || this.text.length == 0){
        this.emptyList= false;
        this.filterList = [...this.qnrList];
        this.filter = "";
      }
      else{
        this.filterList = [];
        this.emptyList= true;
        this.filter = this.filter.substring(0, this.filter.length - 1);
        for (var i = 0; i < this.qnrList.length; i++) {
          if (this.qnrList[i].surveyName.toLowerCase().includes(this.filter)) {
            this.filterList.push(this.qnrList[i]);
            this.emptyList=false;
          }
        }
      }
    }
  }

  stopSearch(){
    this.filterList = this.qnrList;
    this.filter  =  "";
    this.text = "";
    this.emptyList= false;
  }

  responsesChartDialog(selectedQnr){
    this.dialog.open(ResponseChartComponent,{
      minWidth: '78.4rem',
      minHeight: '38.3rem',
      data: selectedQnr
    })
  }

  // getStatus(status) {
  //   if (status == 'p') {
  //     return 'Published';
  //   }
  //   else {
  //     return 'Draft';
  //   }
  // }
  
  repeaterDialog(qID,action){
    let newSurveyDialogRef = this.dialog.open(RangeForRepeaterDialogComponent, {
      width: '42rem',
      data: {qID: qID , action : action}
    });
    newSurveyDialogRef.afterClosed().subscribe(result => {
      if(result && result.success != false){
        this.GetDetailsOfASubForm(this.qID);
      }
    });
  }

  checkIfrepeater(form){
    if(parseInt(form.max_repeat) > 0 && parseInt(form.min_repeat) > 0)
    {
      return true
    }
    return false;
  }
  getTextTocopy(qnr){
    return window.location.origin +'/fillform/' + qnr.qID;
  }

 copied(evt){
   if(evt.isSuccess)
   {
    this.showToastyService.success('Copied to Clipboard','The link to fill was copied. Happy Surveying!!')
   }
   else
   {
     console.log(evt);
   }
 }

  publishQuestions() {
    var numberOfQues = this.sub_form.reduce((total, value) =>{
      return parseInt(total) + value.question.length;
    }, this.questionsLength);

    if(numberOfQues)
    {
    this.restApiService.publishGroupedForm(this.qID).subscribe(
      result => {
        this.showLoader = false;
        if (result.success != false) {
          var toastOptions: ToastOptions = {
            title: "Published",
            msg: "Your Survey has Successfully published",
            showClose: true,
            timeout: 3000,
            theme: 'bootstrap'
          };
          this.toastyService.success(toastOptions);
        }
        else {
          var toastOptions: ToastOptions = {
            title: "Could not Publish",
            msg: result.msg,
            showClose: true,
            timeout: 3000,
            theme: 'bootstrap'
          };
          this.toastyService.error(toastOptions);
        }
      });
    }
    else{
      console.log('no question present');
    }
  }
}

@Component({
  selector: 'delete-dialog',
  templateUrl: 'delete-dialog.html',
  styleUrls: ['edit-dialog.css']
})
export class DeleteSurveyDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteSurveyDialogComponent>,public restApiService:RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNo(): void {
    this.dialogRef.close();
  }

  onYes(){
    this.restApiService.deleteQnr(this.data.qID,this.data.surveyName,this.data.type).subscribe(
      () => {this.dialogRef.close(true); });
  }
}
@Component({
  selector: 'copy-dialog',
  templateUrl: 'copy-dialog.html',
  styleUrls: ['edit-dialog.css']
})
export class CopySurveyDialogComponent {
  surveyName: any;
  name:any;
  group_name:any = '';
  form_type:boolean = false;
  constructor(
    public dialogRef: MatDialogRef<CopySurveyDialogComponent>,public restApiService:RestApiService, @Inject(MAT_DIALOG_DATA) public data: any){
      copyQnr = this.data.qnr;
      this.surveyName = this.data.surveyName;
      if(copyQnr.group_name != null){
        this.form_type = true;
      }
    }

  onNo(): void {
    this.dialogRef.close(false);
  }

  onYes(){
      let userInput = {}
      if(this.data.form_type != "Master"){
          userInput = {
            surveyName: this.name,
            tagsValue: copyQnr.tags,
            ctg: copyQnr.category,
            priLang: copyQnr.primary_lang,
            secondLang: copyQnr.second_lang,
            type: 1,
            qID: copyQnr.qID,
            num_qns: copyQnr.num_qns,
            src: "sm",
            Questionaire_type: this.data.qnr_type,
            form_type: this.data.form_type,
            parentId: this.data.parent_Id
          };

      }
      else{
        if(copyQnr.group_name != null){
          userInput={
            surveyName:this.name,
            tagsValue:copyQnr.tags,
            ctg:copyQnr.category,
            priLang:copyQnr.primary_lang,
            secondLang:copyQnr.second_lang,
            type:1,
            qID:copyQnr.qID,
            num_qns:copyQnr.num_qns,
            src:"sm",
            Questionaire_type:this.data.qnr_type,
            form_type:this.data.form_type,
            parentId: this.data.parent_Id,
            name: this.group_name
          };
        }
        else {
          userInput = {
            surveyName: this.name,
            tagsValue: copyQnr.tags,
            ctg: copyQnr.category,
            priLang: copyQnr.primary_lang,
            secondLang: copyQnr.second_lang,
            type: 1,
            qID: copyQnr.qID,
            num_qns: copyQnr.num_qns,
            src: "sm",
            Questionaire_type: this.data.qnr_type,
            form_type: this.data.form_type
          };
        }
      }

    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    this.restApiService.copyQnrService(token,userInput).subscribe(
      () => {
        this.dialogRef.close({success:true});
      });
  }
}

@Component({
  selector: 'edit-dialog',
  templateUrl: 'edit-dialog.html',
  styleUrls: ['edit-dialog.css']
})
export class EditSurveyInfoComponent {
  titleValue: string;
  noOfLang:any;
  titleEmpty:string;
  priEmpty:string;
  priLang:any;
  secondLang:any;
  qID :any;

  constructor(
    public dialogRef: MatDialogRef<EditSurveyInfoComponent>,public restApiService:RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) {
      this.titleValue= data.surveyName;
      this.priLang = {name:'English',value:'en'};
      this.qID = data.qID;
      if(this.data.second_lang=='')
      {
        this.noOfLang = {name:'Single',value:'Single Language Form'};
        this.secondLang = {name:'',value:''};
      }
      else{
        this.secondLang = {name:'Hindi',value:'hi'};
        this.noOfLang = {name:'Multiple',value:'Double Language Form'};
      }

  }

  onProceed()
  {
    if(this.noOfLang.name =='Multiple')
      {
        this.secondLang = {name:'Hindi',value:'hi'};
      }
    if(this.titleValue==null || this.titleValue=="" || isUndefined(this.titleValue))
    {
      this.titleEmpty = "on-error";
      this.priEmpty = "";
    }
    else if(this.priLang==null ||this.priLang.value==""||this.priLang.value==null||isUndefined(this.priLang))
    {
      this.titleEmpty = "";
      this.priEmpty = "on-error";
    }
    else {
      let userInput={
        surveyName:this.titleValue,
        priLang:this.priLang.value,
        secondLang:this.secondLang.value,
      };
      this.restApiService.editQnrService(this.qID,userInput).subscribe(
        result => {
          if(result.success!=false)
          {
            this.dialogRef.close({success:true});
          }
          else {
            console.log("fail"+result.msg);
          }

        });
    }
  }

  onDiscard()
  {
    this.dialogRef.close({success:false});
  }

  setLangChoice(lang)
  {
    switch (lang){
      case 'Single':
        this.noOfLang.name = "Single";
        this.noOfLang.value = "Single Language Form";
        this.secondLang = {name:'',value:''};
        break;
      case 'Multiple':
        this.noOfLang.name = "Multiple";
        this.noOfLang.value = "Double Language Form";
        this.secondLang = {name:'',value:''};
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/questionnaires/questionnaires.component.ts